<template>
    <div>
        <div class="total-date">
            <div>
                <span class="text">当日上榜数:</span> 
                <span class="num">{{ summaryData.totalRankCount || 0 }}</span>
            </div>
            <div class="date">
                <span class="text">{{ date }}</span>
                <img @click="calendarShow=true" class="calendar" src="../../../assets/calendar.png">
            </div>
        </div>
        <div class="detail">
            <div class="first">
                <div>涨跌异动</div>
                <div>高换手</div>
                <div>高振幅</div>
            </div>
            <div class="second">
                <div>{{ summaryData.pxChangeSignalCount || 0 }}</div>
                <div>{{ summaryData.turnoverSignalCount || 0 }}</div>
                <div>{{ summaryData.amplitudeSignalCount || 0 }}</div>
            </div>
            <div class="third">
                <div class="item">
                    <div class="money" :class="{'red-money': summaryData.totalRankNetBuySum > 0}">{{ formatUnit(summaryData.totalRankNetBuySum) }}</div>
                    <div class="description">龙虎榜净流入</div>
                </div>
                <div class="item">
                    <div class="money red-money">{{ formatUnit(summaryData.totalRankBuySum) }}</div>
                    <div class="description">龙虎榜资金流入</div>
                </div>
                <div class="item">
                    <div class="money">{{ formatUnit(summaryData.totalRankSaleSum) }}</div>
                    <div class="description">龙虎榜资金流出</div>
                </div>
            </div>
        </div>
        <div class="rank">
            <div class="table-desc">
                <div class="gegu">个股榜单</div>
                <div class="tips">注：上榜次数为三个月内数据</div>
            </div>
        </div>
        <div class="lc">
            <div class="row-head">
                <div class="stock-name-head">股票名称</div>
                <div ref="head" class="head-wrapper" :style="{'transform': `translateX(-${left}px)`}">
                <div class="rank-times-head">上榜次数</div>
                <div class="fu-head">
                    <span @click="pxChangeRateSort">涨跌幅</span>
                    <img class="sort" :src="currentSortPic('pxChangeRate')">
                </div>
                <div class="sale-head">
                    <span @click="totalRankSort">净买卖</span>
                    <img class="sort" :src="currentSortPic('totalRankNetBuySum')">
                </div>
                <div class="reason-head">上榜原因</div>
                </div>
            </div>
            <div class="list-container">
                <div ref="list" @scroll="handleScroll" class="list">
                    <div class="row line" v-for="(iterm, key) in rankList" :key="key" @click="$router.push(`/stock/detail/${iterm.secuCode}.html`)">
                        <div class="stock-name stock-data row-head-still" :style="{'transform': `translateY(-${top}px)`}">
                            <div class="name">{{ iterm.chiNameAbbr }}</div>
                            <div class="code">{{ iterm.secuCode }}</div>
                        </div>
                        <div class="rank-times">
                            <span class="number">{{ iterm.rankCount }}</span>
                        </div>
                        <div class="fu">
                            <span class="percent" :class="[iterm.pxChangeRate > 0 ? 'red-per' : 'green-per']">
                                {{ (iterm.pxChangeRate > 0 ? '+' : '') + (iterm.pxChangeRate * 100).toFixed(2) + '%' }}
                            </span>
                        </div>
                        <div class="sale">
                            <span class="percent" :class="[iterm.totalRankNetBuySum > 0 ? 'red-per' : 'green-per']">
                                {{ formatUnit(iterm.totalRankNetBuySum) }}
                            </span>
                        </div>
                        <div class="reason">
                            <span class="text">{{ iterm.abnormalTypeInfo }}</span>
                        </div>
                    </div>
                    <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler" direction="bottom" :distance="100">
                        <div slot="no-more" ref="nomore" class="tab-spinner">无更多数据</div>
                        <div slot="no-results" class="tab-spinner" ref="noresult">
                            无数据
                        </div>
                        <div slot="spinner" class="tab-spinner" ref="loading">正在加载...</div>
                    </infinite-loading>
                </div>
            </div>
        </div>
        <calendar
            :show.sync="calendarShow"
            :defaultDate="date"
            :enableDate="enableDates"
            :minDate="new Date(date) - 365 * 24 * 3600000"
            @change="handelChange" />
    </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import {request} from '@/api/request';
import {getDateStringForLong, formatUnit} from '@/utils/formatUnit'
import Calendar from '@/utils/calendar/calendar.vue';

export default {
    components: {
        InfiniteLoading,
        calendar: Calendar,
    },
    data() {
        return {
            date: getDateStringForLong(Date.now()),
            summaryData: {},
            infiniteId: +new Date(),
            rankList: [],
            page: 0,
            sortField: 'pxChangeRate', //默认按照涨跌幅倒序
            sortType: 'desc',
            calendarShow: false,
            closeWhenClick: true,
            enableDates: [],
            left: 0,
            top: 0
        }
    },
    async created() {
        this.enableDates = (await this.getTradingDays(365)).map(v => v * 1000);
        this.summaryData = await this.getSummaryData();
    },
    computed: {
        currentSortPic() {
            return (type) => {
                if(type === this.sortField) {
                    if (this.sortType == 'desc') {
                        return require('../../../assets/sort-desc.png');
                    } else {
                        return require('../../../assets/sort-asc.png');
                    }
                }
                return require('../../../assets/sort-default.png');
            }
        }
    },

    methods:{
        async getSummaryData() {
            return await request.get({
            url: request.apis.rank.summary,
            params: {
                tradingDay: this.date
            }
        });   
        },
        handelChange(date){
            const newDate = getDateStringForLong(date);
            if(newDate == this.date) return;
            this.date = newDate;
            this.refreshPageData();
        },
        formatUnit(val) {
            if(!val) return 0;
            return formatUnit(val);
        },
        async getList() {
            // 上榜个股列表
            const res = await request.get({
                url: request.apis.rank.list,
                params: {
                    page: this.page + 1,
                    tradingDay: this.date,
                    sortField: this.sortField,
                    sortType: this.sortType,
                    pageSize: 30
                }
            });
            if(res.list && res.list.length) {
                this.page += 1;
                return res.list
            }
            return [];
        },
        async infiniteHandler($state) {
            const list = await this.getList(this.page);
            if (list.length) {
                this.rankList = this.rankList.concat(list);
                $state.loaded();
            } else {
                $state.complete();
            }
        },

        async refreshPageData() {
            this.regetList();
            this.summaryData = await this.getSummaryData();
        },

        regetList(){
            this.rankList = [];
            this.page = 0
            this.infiniteId += 1;
        },
        pxChangeRateSort() {
            if (this.sortField === 'pxChangeRate') {
                this.sortType = (this.sortType === 'desc') ? 'asc' : 'desc';
            } else {
                this.sortType = 'desc';
            }
            this.sortField = 'pxChangeRate';
            this.regetList();
        },
        totalRankSort() {
            if (this.sortField === 'totalRankNetBuySum') {
                this.sortType = (this.sortType === 'desc') ? 'asc' : 'desc';
            } else {
                this.sortType = 'desc';
            }
            this.sortField = 'totalRankNetBuySum';
            this.regetList();
        },
        async getTradingDays(limit = 3, market = 'sh') {
            return await request.get({
                url: request.apis.quote.tradingdays,
                params: {
                    market,
                    limit
                }
            })
        },
        handleScroll() {
            this.left = this.$refs.list.scrollLeft;
            this.top = this.$refs.list.scrollTop;
        }
    }
    
}
</script>
<style lang="stylus" src="./dragon-tiger.styl" scoped></style>